"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCloseFullscreenIcon = void 0;
var createCloseFullscreenIcon = function createCloseFullscreenIcon() {
  var closeFullscreenIcon = document.createElement('div');
  closeFullscreenIcon.className = 'cloudimage-360-close-fullscreen-icon';
  return closeFullscreenIcon;
};
exports.createCloseFullscreenIcon = createCloseFullscreenIcon;